import type { NavigationGuard, Router } from 'vue-router';
import { useMode } from '@/modules/mode/composables';

export const requireMode: NavigationGuard = async (_to, _from, next) => {
  const { resolvedMode } = useMode();
  const currentMode = await resolvedMode();
  if (currentMode === 'federated') return next('/f/');
  if (currentMode === 'client') return next('/c/');
  if (currentMode === 'supplier') return next('/s/');
  if (currentMode === '') return next('/n/');
  next();
};

// Applies the route's mode only once navigation is confirmed. Setting it in a
// guard would re-render the outgoing page with the incoming route's mode while
// the guards and lazy layout are still resolving.
export function syncModeWithRoute(router: Router) {
  router.afterEach((to, _from, failure) => {
    if (failure) return;
    if (typeof to.meta.mode !== 'string') return;
    useMode().setMode(to.meta.mode);
  });
}
